// extracted by mini-css-extract-plugin
export default {"card":"Sources_card__b+5+I","title":"Sources_title__SMqNz","copy_btn":"Sources_copy_btn__4jfv9","validationMessage":"Sources_validationMessage__4NTYg"};